const _excluded = ["archive", "name"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { useArchiveMimeType, useArchiveName } from "./hooks";
import { ViewerArchiveContainer } from "./viewer/container";
import { ViewArchiveInfoError } from "./viewer/status";
import { ViewArchivePdf } from "./viewer/archive/pdf";
import { ViewArchiveCsv } from "./viewer/archive/csv";
import { ViewArchiveHtml } from "./viewer/archive/html";
import { ViewArchiveCss, ViewArchiveTxt, ViewArchiveXml } from "./viewer/archive/text";
import { ViewArchiveZip } from "./viewer/archive/zip";
import { ViewArchiveJson } from "./viewer/archive/json";
import { ViewArchiveTiff } from "./viewer/archive/tiff";
import { ViewArchiveImage } from "./viewer/archive/image";
import { ViewArchiveVideo } from "./viewer/archive/video";
import { ViewArchiveAudio } from "./viewer/archive/audio";
import { ViewArchiveExcel } from "./viewer/archive/excel";
import { ViewArchiveWord } from "./viewer/archive/word";
import { ViewArchiveFallback } from "./tools";
import '@isyc-react/design/main';

// TODO granulate components and allow use any for every archive type etc all with ViewArchiveProps
// Common web mime types: https://developer.mozilla.org/es/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
// Mime types iso: https://www.iana.org/assignments/media-types/media-types.xhtml
// TODO not only check mimeType, extension too, and if mime is text/plain or
// application/octet-stream, check extension (make ext toLowerCase) for mapping *****
// TODO allow passing mimetype in props too?

export const ViewArchive = props => {
  const {
      archive,
      name: overridedName
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const name = useArchiveName(archive, overridedName);
  const {
    mimeType,
    error
  } = useArchiveMimeType(archive);

  // console.log('Mime type: ', mimeType, error, archive)

  if (error) return /*#__PURE__*/React.createElement(ViewerArchiveContainer, null, /*#__PURE__*/React.createElement(ViewArchiveInfoError, null, "Error getting archive mime type"));
  if (!mimeType) return null; // Loading ... // TODO loading screen just for http mime types ?

  switch (mimeType) {
    // -- Documents --
    case 'application/pdf':
      // pdf
      return /*#__PURE__*/React.createElement(ViewArchivePdf, _extends({
        archive: archive,
        name: name
      }, rest));
    case 'text/csv':
      // csv
      return /*#__PURE__*/React.createElement(ViewArchiveCsv, _extends({
        archive: archive,
        name: name
      }, rest));
    case 'text/html':
      // html
      return /*#__PURE__*/React.createElement(ViewArchiveHtml, _extends({
        archive: archive,
        name: name
      }, rest));
    case 'text/xml': // xml
    case 'application/xml': //xml
    case 'application/xhtml+xml':
      // xhtml // TODO also with html view?
      return /*#__PURE__*/React.createElement(ViewArchiveXml, _extends({
        archive: archive,
        name: name
      }, rest));
    // text/x-scss // scss
    // text/x-sass // sass
    case 'text/css':
      //css
      return /*#__PURE__*/React.createElement(ViewArchiveCss, _extends({
        archive: archive,
        name: name
      }, rest));
    case 'text/plain':
      // txt
      return /*#__PURE__*/React.createElement(ViewArchiveTxt, _extends({
        archive: archive,
        name: name
      }, rest));
    case 'application/doc': // doc,docx
    case 'application/ms-doc': // doc,docx
    case 'application/msword': // doc,docx
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
      // doc,docx
      return /*#__PURE__*/React.createElement(ViewArchiveWord, _extends({
        archive: archive,
        name: name
      }, rest));

    // application/mspowerpoint // ppt,pptx
    // application/powerpoint // ppt,pptx
    // application/vnd.ms-powerpoint // ppt,pptx
    // application/x-mspowerpoint // ppt,pptx
    // application/vnd.openxmlformats-officedocument.presentationml.presentation // ppt,pptx

    case 'application/excel': // xls,xlsx // TODO make a Web Worker (1MB) with xlsx lib it also parses ODS, CSV, etc
    case 'application/vnd.ms-excel': // xls,xlsx
    case 'application/x-excel': // xls,xlsx
    case 'application/x-msexcel': // xls,xlsx
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': // xls,xlsx
    case 'application/vnd.oasis.opendocument.spreadsheet':
      // ods
      // TODO check all the allowed xlsx lib extensions, rtf should work, etc... (https://www.npmjs.com/package/xlsx)
      return /*#__PURE__*/React.createElement(ViewArchiveExcel, _extends({
        archive: archive,
        name: name
      }, rest));

    // application/vnd.oasis.opendocument.text // odt
    // application/vnd.oasis.opendocument.presentation // odp
    // application/rtf // rtf // TODO rtf should work with the Excel (xlsx library) -> check it out
    case 'application/zip':
      // zip // TODO make a Web Worker too? (usually blocks JS thread for 1-2seg)
      return /*#__PURE__*/React.createElement(ViewArchiveZip, _extends({
        archive: archive,
        name: name
      }, rest));
    // application/x-7z-compressed // 7z
    // application/x-tar // tar
    // application/x-rar-compressed // rar

    case 'application/json':
      // json
      return /*#__PURE__*/React.createElement(ViewArchiveJson, _extends({
        archive: archive,
        name: name
      }, rest));

    // -- Images --
    case 'image/tiff': // tiff,tif
    case 'image/x-tiff': // tiff,tif
    case 'image/CR2': // cr2
    case 'image/NEF': // nef
    case 'image/DNG':
      // dng
      return /*#__PURE__*/React.createElement(ViewArchiveTiff, _extends({
        archive: archive,
        name: name
      }, rest));
    case 'image/png': // png
    case 'image/jfif': // jfif
    case 'image/jpeg': // jpg,jpeg
    case 'image/pjpeg': // jpg,jpeg
    case 'image/webp': // webp
    case 'image/gif': // gif
    case 'image/x-icon': // ico
    case 'image/vnd.microsoft.icon': // ico
    case 'image/bmp': // bmp
    case 'image/svg+xml':
      // svg
      return /*#__PURE__*/React.createElement(ViewArchiveImage, _extends({
        archive: archive,
        name: name
      }, rest));
    // image/svg+xml (works in chrome at least)
    // image/bmp (works in chrome at least)
    // image/x-icon (image/x-icon and image/vnd.microsoft.icon works in chrome at least)

    // TODO improve video and audio players and its supported mime types??
    // TODO look for this file types .m4v , .mov , .wmv, .mpeg , .mkv , .wav too ***
    // -- Video --
    case 'application/x-troff-msvideo': // avi
    case 'video/avi': // avi
    case 'video/msvideo': // avi
    case 'video/x-msvideo': // avi
    case 'video/mp4': // mp4
    case 'application/mp4': // mp4
    case 'video/mpeg': // mpeg
    case 'video/x-mpeg': // mpeg
    case 'video/ogg': // ogv,ogg
    case 'video/webm':
      // webm
      return /*#__PURE__*/React.createElement(ViewArchiveVideo, _extends({
        archive: archive,
        name: name
      }, rest));
    // video/x-ms-wmv // wmv
    // video/x-ms-asf // wmv
    // video/3gpp // 3gp
    // video/3gpp2 // 3gp2

    // -- Audio --
    case 'audio/ogg': // oga,ogg
    case 'audio/webm': // webm
    case 'audio/mpeg': // mp3
    case 'audio/mpeg3': // mp3
    case 'audio/x-mpeg-3': // mp3
    case 'audio/wav': // wav
    case 'audio/x-wav':
      // wav
      // audio/3gpp // 3gp
      // audio/3gpp2 // 3gp2
      return /*#__PURE__*/React.createElement(ViewArchiveAudio, _extends({
        archive: archive,
        name: name
      }, rest));
    default:
      return /*#__PURE__*/React.createElement(ViewArchiveFallback, {
        archive: archive,
        name: name,
        mime: mimeType
      });
  }
};